module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Abrhkm/tc-custom/9781439672242.jpg?1702530540631",
      "alt": "This image is the cover for the book Buffalo Soldiers on the Colorado Frontier, Military"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Buffalo Soldiers on the Colorado Frontier, Military\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The legendary Buffalo Soldiers, four army regiments of former slaves, were vital in taming the American frontier. The Tenth Cavalry of African American troopers rode across the Colorado plains to battle the Cheyennes and rescue wounded, starving soldiers at Beecher Island on the Arikaree River. Under the cover of darkness, the Ninth Cavalry aided besieged troops pinned down by Ute sharpshooters at Milk Creek. They drove off Cheyenne Dog Soldiers attacking a stagecoach of nervous travelers on the Smokey Hill Trail to Denver. And they braved howling blizzards and deep snowdrifts to protect lonely homesteads and wandering prospectors. Author Nancy K. Williams details the bravery and valor of these historic servicemen who served proudly defending America's Wild West.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Nancy K. Williams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Exploring mountains, old abandoned mining camps and deserted diggings has always fascinated Nancy. A lifetime in the West has given her plenty of opportunities to learn about the many different people who struggled to carve out their lives amid its beauty and massive challenges. Her first magazine article was about a haunted Mother Lode hotel, and it was followed by many others and three books on \"Haunted Hotels\" in California Gold Country, Northern Colorado and Southern Colorado.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0